export default __webpack_public_path__ + "static/media/Collab13.c514527b.png";